import { Record } from "immutable";

export type ModuleId = string;
export type ContentId = string;

export type ContentModuleType<Content> = {
  id: ModuleId | undefined;
  parentId: ContentId | undefined;
  moduleType: string;
  content: Content;
  moduleDifficulty: number | null;
};

export type OptionalContentModuleType<Content> = Partial<
  ContentModuleType<Content>
>;

const defaultModule: ContentModuleType<any> = {
  id: undefined,
  parentId: undefined,
  moduleType: "unknown",
  content: null,
  moduleDifficulty: null
};

export default class ContentModule extends Record(defaultModule) {}
